import {FigureMainClass} from "./figureMainClass";
import {ObjectConfig} from "../../models/ObjectConfig";
import {MapPosition} from "../../models/MapPosition";
import {from} from "rxjs";

export class Point extends FigureMainClass {
  public position : MapPosition;

  __init(object : ObjectConfig) {
    this.position = object.getPosition();
  }

  public draw() {
    return from(new Promise((resolve, reject) => {
      this.view.drawPoint(this.tool, this.position);
      resolve({});
    }));
  }
  getLinkedObjectsAnchorPosition(){
    return this.position;
  }
}
